// extracted by mini-css-extract-plugin
module.exports = {"sitemap":"sitemap_sitemap__7VuuQ","list_item":"sitemap_list_item__m8ay3"};